import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-8 px-12 pb-12 lg:pb-16 bg-stripes text-center" }
const _hoisted_2 = { class: "text-right mb-4" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute w-6 top-4 right-4 text-neutral-400" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "external-link-alt",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    class: "svg-inline--fa fa-external-link-alt fa-w-16 fa-3x"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z",
      class: ""
    })
  ])
], -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "underline" }
const _hoisted_7 = { class: "text-center justify-center" }
const _hoisted_8 = { class: "text-2xl lg:text-3xl text-[#4b89a6] mb-1" }
const _hoisted_9 = { class: "mb-10 text-neutral-400" }
const _hoisted_10 = { class: "text-sm max-w-md mx-auto whitespace-pre-line text-justify" }
const _hoisted_11 = { class: "mt-12 flex flex-wrap gap-12 px-12 max-w-7xl mx-auto" }
const _hoisted_12 = { class: "basis-full md:basis-[calc(50%-1.5rem)]" }
const _hoisted_13 = { class: "text-2xl uppercase text-[#9aa83a] text-center border border-neutral-800 p-4 rounded" }
const _hoisted_14 = { class: "text-xl p-4 text-center" }
const _hoisted_15 = { class: "basis-full md:basis-[calc(50%-1.5rem)]" }
const _hoisted_16 = { class: "text-2xl uppercase text-[#9aa83a] text-center border border-neutral-800 p-4 rounded" }
const _hoisted_17 = { class: "text-xl p-4 text-center" }
const _hoisted_18 = {
  key: 0,
  class: "mt-12 px-12 max-w-7xl mx-auto"
}
const _hoisted_19 = { class: "text-2xl uppercase text-[#9aa83a] text-center border border-neutral-800 p-4 rounded mb-6" }
const _hoisted_20 = { class: "flex flex-wrap" }
const _hoisted_21 = { class: "mx-auto" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocaleSwitch = _resolveComponent("LocaleSwitch")!
  const _component_JbMainContainer = _resolveComponent("JbMainContainer")!

  return (_openBlock(), _createBlock(_component_JbMainContainer, {
    p: "0",
    bg: "bg-neutral-900"
  }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_LocaleSwitch)
        ]),
        _createElementVNode("a", {
          class: "relative inline-flex flex-wrap flex-col lg:flex-row justify-center items-center gap-x-12 gap-y-6 px-12 py-8 lg:px-16 mb-6 rounded-lg bg-neutral-700/75 drop-shadow-xl",
          href: _ctx.references[_ctx.$route.params.name].link
        }, [
          _hoisted_4,
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              class: "mx-auto w-48 md:w-52 aspect-square object-contain rounded-full drop-shadow-lg bg-white mb-8 p-4",
              src: _ctx.references[_ctx.$route.params.name].cover_img,
              alt: "Joris BROLL"
            }, null, 8, _hoisted_5),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.references[_ctx.$route.params.name].link), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.references[_ctx.$route.params.name].title), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t(`common.${_ctx.references[_ctx.$route.params.name].type}`)), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('references.'+_ctx.$route.params.name+'.description')), 1)
          ])
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t('references.titles.date')), 1),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.references[_ctx.$route.params.name].date), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t('references.titles.tech_stack')), 1),
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.references[_ctx.$route.params.name].tech_stack), 1)
        ])
      ]),
      (_ctx.references[_ctx.$route.params.name].screens)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$tc('references.titles.screenshots', _ctx.references[_ctx.$route.params.name].screens)), 1),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.references[_ctx.$route.params.name].screens, (screen, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: screen,
                  class: ""
                }, [
                  _createElementVNode("figure", _hoisted_21, [
                    _createElementVNode("img", {
                      class: "mx-auto bg-neutral-200 rounded-lg mb-8",
                      src: screen
                    }, null, 8, _hoisted_22),
                    _createElementVNode("figcaption", _hoisted_23, _toDisplayString(_ctx.$t(`references.${_ctx.$route.params.name}.screens[${index}]`)), 1)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}